var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "url(#white-rounded_svg__paint0_linear_2155_6458)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 15.709,
  width: 3.154,
  height: 13.44,
  rx: 1.577,
  fill: "#B4283D"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.423,
  y: 15.709,
  width: 3.154,
  height: 13.44,
  rx: 1.577,
  fill: "#B4283D"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 28.846,
  y: 15.709,
  width: 3.154,
  height: 13.44,
  rx: 1.577,
  fill: "#3098C8"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 13.143,
  y: 10.84,
  width: 3.154,
  height: 18.309,
  rx: 1.577,
  fill: "#B4283D"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 23.566,
  y: 10.84,
  width: 3.154,
  height: 18.309,
  rx: 1.577,
  fill: "#3098C8"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint0_linear_2155_6458",
  x1: 0,
  y1: 0,
  x2: 40,
  y2: 40,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#111C2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#172837"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yMTU1XzY0NTgpIi8+CjxyZWN0IHg9IjgiIHk9IjE1LjcwODYiIHdpZHRoPSIzLjE1NDI5IiBoZWlnaHQ9IjEzLjQ0IiByeD0iMS41NzcxNCIgZmlsbD0iI0I0MjgzRCIvPgo8cmVjdCB4PSIxOC40MjI5IiB5PSIxNS43MDg2IiB3aWR0aD0iMy4xNTQyOSIgaGVpZ2h0PSIxMy40NCIgcng9IjEuNTc3MTQiIGZpbGw9IiNCNDI4M0QiLz4KPHJlY3QgeD0iMjguODQ1NyIgeT0iMTUuNzA4NiIgd2lkdGg9IjMuMTU0MjkiIGhlaWdodD0iMTMuNDQiIHJ4PSIxLjU3NzE0IiBmaWxsPSIjMzA5OEM4Ii8+CjxyZWN0IHg9IjEzLjE0MjgiIHk9IjEwLjg0IiB3aWR0aD0iMy4xNTQyOSIgaGVpZ2h0PSIxOC4zMDg2IiByeD0iMS41NzcxNCIgZmlsbD0iI0I0MjgzRCIvPgo8cmVjdCB4PSIyMy41NjU3IiB5PSIxMC44NCIgd2lkdGg9IjMuMTU0MjkiIGhlaWdodD0iMTguMzA4NiIgcng9IjEuNTc3MTQiIGZpbGw9IiMzMDk4QzgiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yMTU1XzY0NTgiIHgxPSIwIiB5MT0iMCIgeDI9IjQwIiB5Mj0iNDAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzExMUMyQSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxNzI4MzciLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };